export default __webpack_public_path__ + "static/media/finalizeProjectSetup.e0d4ac26.png";